
const Apiurl = 'https://manager.enjoytool.net/backend';
//const Apiurl = 'http://localhost:1806';
export default Apiurl
